import React, {useContext} from 'react';
import {Route, Redirect} from 'react-router-dom';
import AuthContext from "../../contexts/auth/AuthContext";
import routes from "../../routing/routes";


export default function AuthRoute({component: Component, ...rest}) {

    const {user} = useContext(AuthContext);

    const render = (props) => {
        if (user !== null) {
            return <Redirect to={{pathname: routes.home.getUrl()}}/>;
        }

        return <Component {...props}/>;
    };

    return <Route {...rest} render={render}/>;
}
